import { render, staticRenderFns } from "./CambiaFP.vue?vue&type=template&id=a0e18c30&scoped=true&lang=pug"
import script from "./CambiaFP.vue?vue&type=script&lang=js"
export * from "./CambiaFP.vue?vue&type=script&lang=js"
import style0 from "./CambiaFP.vue?vue&type=style&index=0&id=a0e18c30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e18c30",
  null
  
)

export default component.exports